import { AspectRatio } from '@/components/ProductCard';
import { VARIANT_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';

export function useProductCardAspectRatio() {
  const { web_portrait_product_card } = useExperiments([
    'web_portrait_product_card',
  ]);

  const isPortrait = web_portrait_product_card === VARIANT_IDENTIFIER;

  return {
    isPortrait,
    aspectRatio: isPortrait ? AspectRatio.Portrait : AspectRatio.Square,
  };
}
